import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../text/text';
import styles from './snapshot_title.css';

/**
 * SnapshotTitle component for Snapshot Containers
 * @param {String} title The title for the Title
 * @param {String} size The title text size
 * @param {String} color The title text color
 * @return {Node} SnapshotTitle returns SnapshotTitle component
 */
const SnapshotTitle = ({ title, size, color }) => {
    return title ? (
        <div className={styles.container}>
            <Text size={size} color={color}>
                {title}
            </Text>
        </div>
    ) : null;
};

SnapshotTitle.propTypes = {
    title: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string
};

SnapshotTitle.defaultProps = {
    size: 'large_semi_bold',
    color: 'brand_base_120'
};

export { SnapshotTitle };
